import { createSlice } from '@reduxjs/toolkit';

const freeBetsStateSlice = createSlice({
  name: 'freeBetsState',
  initialState: false,
  reducers: {
    toggleFreeBetsState: (state, action) => {
      state = action.payload;
      return state;
    }
  },
});

export const { toggleFreeBetsState } = freeBetsStateSlice.actions;
export default freeBetsStateSlice.reducer;
